import { render, staticRenderFns } from "./McLayoutFullScreen.vue?vue&type=template&id=27c7cfda"
import script from "./McLayoutFullScreen.vue?vue&type=script&lang=js"
export * from "./McLayoutFullScreen.vue?vue&type=script&lang=js"
import style0 from "./McLayoutFullScreen.vue?vue&type=style&index=0&id=27c7cfda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports